// import logo from './logo.svg';
import './App.css';
import React, {useState} from 'react';

function App() {
  const [isSubmitted, updateIsSubmitted] = useState(false);
  const [isValid, updateIsValid] = useState(false);
  const [responseData, updateResponseData] = useState(null);



  const handleSubmit = async () => {

    //check file, check data
    const fileUpload = document.getElementById('fileUpload').files[0];
    const taxAllowance = document.getElementById('taxAllowance').value;
    const taxRate = document.getElementById('taxRate').value;
    const partialExemption = document.getElementById('partialExemption').value;
    const salesPrice = document.getElementById('salesPrice').value;


    // check correct data formats, numbers, etc.
    //console.log(fileUpload);
    //console.log(taxAllowance);
    //console.log(taxRate);
    //console.log(partialExemption);
    //console.log(salesPrice);

    
    const formData = new FormData();

    formData.append('fileUpload', fileUpload);
    formData.append('taxAllowance', taxAllowance);
    formData.append('taxRate', taxRate);
    formData.append('partialExemption', partialExemption);
    formData.append('salesPrice', salesPrice);


    try{
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/echo", {method: 'POST', body: formData});
      
      // const data = await response.json();
      const data = await response.json();

      updateIsSubmitted(true);
      updateResponseData(data);
      if (response.status === 200) {
        updateIsValid(true)
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
    //console.log(responseData);
  };

  return(
    <div className='App' id="app">
      <div id='input_area'>
      <div id='document_format'>
        Verwende das folgende Format in der .csv-Datei:
        <br/>
        Erste Zeile:
        Date;Amount;Price
        <br/>
        Weitere Zeilen: 
        DD.MM.YY;1.234;1234
        <br/>
      {/*NOTE: MAKE  FILE MORE ADAPTABLE!!! USE DYNAMIC FINDING OF CORRECT*/}
      </div>
      <div id='data_form'>
        <label for='fileUpload'>Upload .csv: </label>
        <input type='file' name='fileUpload' id='fileUpload' accept='.csv'></input>

        <br/>
        <label for='taxAllowance'>Auszuschöpfender Freibetrag: </label>
        <input type='number' name='taxAllowance' id='taxAllowance'></input>

        <br/>
        <label for='taxRate'>Steuersatz: </label>
        <input type='number' name='taxRate' id='taxRate'></input>

        <br/>
        <label for='partialExemption'>Höhe der Teilfreistellung: </label>
        <select id='partialExemption'>
          <option value='0'>0%</option>
          <option value='15'>15%</option>
          <option value='30'>30%</option>
        </select>

        <br/>
        <label for='salesPrice'>Voraussichtlicher Verkaufspeis: </label>
        <input type='number' name='salesPrice' id='salesPrice'></input>

        <br/>
        <button id="submitButton" onClick={handleSubmit}>Berechnen</button>

        {isSubmitted && responseData && isValid ? (
          <div>
            {displayTable(responseData.rawTransactionData)}
            <p>Gewichteter Freibetrag: {responseData.totalExemption}€</p>
            <p>{responseData.message}</p>
            {/*<p>Es verbleiben folgende Transaktionen</p>*/}
            {/*displayTable(responseData.processedTransactions)*/}
          </div>
        ): null}
      </div>
    </div>
    </div>
  )
}

function displayTable(data) {
  return(
    <div>
      <table>
        <tr>
          <th>Datum</th>
          <th>Anzahl</th>
          <th>Preis</th>
        </tr>
      {data.map((transaction, i) => (
      <tr id={'transaction'+i}>
        <td>{transaction.date}</td>
        <td>{transaction.amount}</td>
        <td>{transaction.price}</td>
      </tr>
    ))}
    </table>
    </div>
  )
}

export default App;
